import {
  PaymentStrategiesIds,
  PaymentStrategy,
} from '@/services/paymentService';
import { Toast } from '@/ui/toast';
import { SettingsInfo } from '@/services/settingsService';
import { DeviceIds, deviceType } from '@/core/environment/deviceType';
import YourPluginKeyModal from '../account/accountModal/pluginKeySection/modals/YourPluginKeyModal';
import AutoColorDiscoveryModal from '../autoColorDiscovery/AutoColorDiscoveryModal';
import { isAutoColorDiscoveryEnabled } from '../autoColorDiscovery/config';

type ShowSuccessToastProps = {
  selectedPaymentStrategy: PaymentStrategy | null;
  shouldShowMarketingConsentModal: () => void;
  pushModal: (modal: any) => void;
  settings: SettingsInfo;
  message: string;
  webOnboardingUserId?: string;
  // The Auto Color discovery modal only makes sense on an editable result.
  hasEditableMedia: boolean;
};

export default function maybeShowSuccessToast({
  selectedPaymentStrategy,
  shouldShowMarketingConsentModal,
  pushModal,
  message,
  settings,
  webOnboardingUserId,
  hasEditableMedia,
}: ShowSuccessToastProps) {
  pushModal({
    id: 'subscriptionToast',
    Modal: Toast,
    message,
    icon: null,
    duration: 2000,
    onEnd: () => shouldShowMarketingConsentModal(),
    onClose: () => {
      // Discovery spotlight (Janus-gated, desktop only, with an editable result)
      // takes precedence over the Photoshop plugin prompt: only one
      // post-conversion modal is shown. Auto Color only exists on the desktop
      // image editor and needs a photo to apply to.
      if (
        isAutoColorDiscoveryEnabled(settings.values.autoColorDiscovery) &&
        deviceType() === DeviceIds.Desktop &&
        hasEditableMedia
      ) {
        pushModal({
          id: 'auto-color-discovery-modal',
          Modal: AutoColorDiscoveryModal,
        });
        return;
      }

      if (
        settings.values.psPlugin &&
        selectedPaymentStrategy?.id === PaymentStrategiesIds.Business &&
        !webOnboardingUserId
      ) {
        pushModal({
          id: 'generate-plugin-key-modal',
          Modal: YourPluginKeyModal,
        });
      }
    },
  });
}
